import React from "react";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import AgribusinessStack from "../AgribusinessStack/AgribusinessStack";
import './ForAgriTransporter.css';
// Main component for DTN Deployment for Agri-Transporters
export default function ForAgriTransporter() {
  return (
    <>
      {/* Banner section */}
      <AgribusinessStack
        classname="agri-transporter"
        level1="System Integrator"
        level2="Agribusiness"
        level3="Agri-Transporters"
      />

      {/* Section representing DTN deployment for agri-transporters */}
      <SolutionEcosystem
        title="DTN Deployment for Agri-Transporters"
        type="AT"
        bodycopy="ACN is a type of DTN network where agri-transporters can join to monetize unutilized transportation capacity."
      />
    </>
  );
}

